import React from 'react';

const PlayIcon = () => (
  <svg
    width="30"
    height="36"
    viewBox="0 0 30 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M30 18L0 .68v34.64L30 18z" fill="#fff" />
  </svg>
);

export default PlayIcon;
